<template>
  <RewardsForm is-new />
</template>

<script>
import RewardsForm from '../components/RewardsForm.vue'

export default {
  components: { RewardsForm },
}
</script>
